import { FC } from 'react';

import { EStatisticType } from "views/Statistics/StatisticsView.types";

import { AnalyticsTooltipSeparator } from "../AnalyticsTooltipSeparator";
import { getDescriptiveLabelFromDate, getFormattedValueByType } from "../utils";

type SingleTrendLegendProps = {
    time: string
    currentValue: number
    metricType: EStatisticType
}

export const SingleTrendLegend: FC<SingleTrendLegendProps> = ({time, currentValue, metricType}) => {
    return (
        <div>
            <p className="text-base-popoverForeground text-p-xs">{getDescriptiveLabelFromDate(time)}</p>
            <AnalyticsTooltipSeparator />
            <p className="text-base-popoverForeground text-p-m">{getFormattedValueByType(currentValue, metricType)}</p>
        </div>
    )
}